import React, { useState, useEffect } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import "./table.css"
import { Modal, Button, Form } from 'react-bootstrap';
import ApiService from '../../../EpicGame/services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RxCross2 } from "react-icons/rx";
const ContinuousPage = () => {
    const apiService = new ApiService()
    const location = useLocation();
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        lowprice: "",
        heighPrice: '',
        negativeLevel: ''
    });
    const [continuous, setContinuous] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [selectedGames, setSelectedGames] = useState([]);
    const [negi, setNegi] = useState();

    const item = location.state;
    useEffect(() => {
        fetchuser();
    }, []);

    const fetchuser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('name', formData?.lowprice || "");
            params.append('price', formData?.heighPrice || "");
            const response = await apiService.getApiParamater('GAME_LIST', `?${params.toString()}`);
            setRowData(response?.data);
            const Gameparams = new URLSearchParams();
            Gameparams.append('userId', item?.id || "");
            const gameResponse = await apiService.getApiParamater('GET_NAGITIVE', `?${Gameparams.toString()}`);
            setSelectedGames(gameResponse?.data)
            if (gameResponse?.data?.length < 1) {
                setNegi(true)
            } else if (gameResponse?.data === "No negative levels found for this user.") {
                setNegi(false)
            }
        } catch (error) {
            console.error("Error fetching Currency data:", error);
            setNegi(false)
        }
    };
    const handleReset = () => {
        setFormData({
            lowprice: "",
            heighPrice: '',
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate' || name === 'toDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleContinuousClick = async (user) => {
        try {
            setSelectedGames(prev => {
                if (prev.find(game => game.id === user.id)) return prev;
                return [...prev, user];
            });
        } catch (error) {
            console.error("Error Creating order:", error);
        }
    };
    const handleRemoveGame = (id) => {
        setSelectedGames(prev => prev.filter(game => game.id !== id));
    };
    const handlesaveNegative = async () => {
        const baseNegativeLevel = parseInt(formData.negativeLevel); // or Number()
        try {
            if (!baseNegativeLevel) {
                toast.warning("Please Enter  Continuous orders")
                return
            }
            const games = selectedGames
                ?.filter(g => g.negativeLevel === undefined || g.negativeLevel === null) // skip if negativeLevel already exists
                .map((gme, index) => ({
                    userId: item.id,
                    memberAccountLevelId: item.memberLevel,
                    negativeLevel: baseNegativeLevel + index,
                    gameName: gme.name,
                    gamePrice: parseInt(gme.price),
                    gameId: gme.id,
                }));
            const response = await apiService.post('SET_NEGATIVE', games);
            if (response?.data?.statusCode === 200) {
                toast.success(response?.data?.message)
                // navigate('/UserList');
                window.location.reload();
            }
        } catch (error) {
            console.error("Error set Negative:", error);
            toast.error(error?.response?.data.message)
        }
    };
    const handleDelete = async () => {
        const games = selectedGames?.map(gme => gme.id);
        let body = {
            ids: games
        }
        try {
            const response = await apiService.post('DELETE_NEGITIVE', body);
            if (response?.data === "User negative levels deleted successfully.") {
                setSelectedGames([])
                setFormData({ ...formData, negativeLevel: "" });
            }
        } catch (error) {
            console.error("Error set Negative:", error);
            toast.error(error?.response?.data.message)
        }
    };
    const handleResetGames = async () => {
        setSelectedGames([])
        setFormData({ ...formData, negativeLevel: "" });
    };
    return (
        <div className='p-5 background'>
            <div className='blackBox p-4 mt-3' style={{ background: "#fff" }}>
                <div className='d-flex gap-3 '>
                    <h5>Current User : </h5>
                    <h5>{item?.username}</h5>
                </div>
                <div className='gap-2'>
                    <label htmlFor="validationCustom01" className="form-label">Current Numbers of orders made</label>
                    <input type='text' className="form-control w-25" disabled name='heighPrice' value={item?.numberofdraws} />
                </div>
                <div className='gap-2 my-3'>
                    <label htmlFor="validationCustom01" className="form-label">Orders Received Today</label>
                    <input type='text' className="form-control w-25" disabled name='heighPrice' value={item?.playedGames} />
                </div>
                <div className='gap-2'>
                    <label htmlFor="validationCustom01" className="form-label">Maximum Orders Received by level</label>
                    <input type='text' className="form-control w-25" disabled name='heighPrice' value={item?.totalGames} />
                </div>
                <div className='gap-2 my-3'>
                    <label htmlFor="validationCustom01" className="form-label">Start Continuous orders after several orders</label>
                    <input type='number' className="form-control w-25" name='negativeLevel' value={formData?.negativeLevel} onChange={handleInputChange} />
                </div>
                <div className='d-flex gap-3'>
                    <label htmlFor="validationCustom01" className="form-label">Products  :</label>
                    <label htmlFor="validationCustom01" className="form-label text-success">Please seletc Continuous orders in the product list</label>
                </div>
                <div className="mt-2 d-flex flex-wrap gap-2">
                    {selectedGames?.map((game) => (
                        <div key={game.id} className="badge bg-success text-white d-flex align-items-center px-2 py-1" style={{ borderRadius: '8px' }}>
                            <div>
                                <h6>{game?.negativeLevel ? `Level : ${game?.negativeLevel}` : ""}   {game.price || game.gamePrice ? `Price : ${game.price || game.gamePrice}` : ""}</h6>
                                <h6>{game.name || game.gameName}</h6>
                            </div>
                            {/* <button
                                onClick={() => handleRemoveGame(game.id)}
                                className="btn btn-sm btn-light ms-2 p-0"
                                style={{ lineHeight: 1, fontSize: '14px', width: '40px', height: '40px', borderRadius: '10%' }}
                            >
                                <RxCross2 size={25} />
                            </button> */}
                        </div>
                    ))}
                </div>
                <div className=' d-flex mt-5 gap-4 col-4'>
                    {negi === false ?
                        <button className="btn btn-success w-50" style={{ fontSize: '14px', padding: '4px 12px' }} onClick={() => handlesaveNegative()}>
                            Ok
                        </button> :
                        <button className="btn btn-success w-50" style={{ fontSize: '14px', padding: '4px 12px' }} onClick={() => handlesaveNegative()}>
                            Update
                        </button>
                    }
                    <button className='btn red w-50' onClick={handleDelete} >Reset</button>
                </div>
            </div>
            <div className='blackBox my-3 p-4' style={{ background: "#fff" }}>
                <div className='row d-flex  py-3 mt-4'>
                    <div className='col-7'>
                        <div className='d-flex gap-2'>
                            <label htmlFor="validationCustom01" className="form-label w-50">Name</label>
                            <label htmlFor="validationCustom01" className="form-label w-50">Price</label>
                        </div>
                        <div className='d-flex gap-2'>
                            <input type='text' className="form-control w-50" name='lowprice' value={formData?.lowprice} placeholder='Enter Name' onChange={handleInputChange} />
                            <input type='number' min={0} className="form-control w-50" name='heighPrice' placeholder='Enter  Price' value={formData?.heighPrice} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='col-3 d-flex gap-3 mt-4'>
                        <button className='btn btn-primary w-50 d-flex center gap-3' type="submit" onClick={fetchuser}><FaSave /><div>Search</div></button>
                        <button className='btn btn-secondary w-50 d-flex center gap-3' onClick={handleReset} ><RiRefreshLine /><div>Reset</div></button>
                    </div>
                </div>
            </div>
            <div className="table-containe ">
                <table className="custom-table">
                    <tbody>
                        {rowData?.map((row) => (
                            <tr key={row.id}>
                                <td>{row.name}</td>
                                <td>{row.minimumPrice}</td>
                                <td>{row.price}</td>
                                <td>{row.minimumPrice}</td>
                                <td className="actions-cell">
                                    <div className="action-row">
                                        <button className="btn btn-success" style={{ fontSize: '14px', padding: '4px 12px' }} onClick={() => handleContinuousClick(row)}>
                                            Add to Continuous Order
                                        </button>
                                        <button className="btn red">Replace next order</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    );
};
export default ContinuousPage;